import axios from 'axios'
//import * as settings from '@/settings'



//const baseUrl = settings.baseUrl + 'api/'

export default class ApiService {
  constructor (url) {
    this.url = url
    /*if (serviceName != null && serviceName !== undefined) {
      this.url = baseUrl + this.serviceName + '/'
    } else {
      this.url = baseUrl
    }*/
    
  }

    // GetAll
    async getAll (filter = {}, sub = '') {
      
      return axios
      .get(this.url)
      .then(response =>  response.data.dados)
    }
 
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js